import styled from 'styled-components';

const ModalTitle = styled.h2`
  margin: 0;
  color: #111827;
  font-weight: 700;
  font-size: 1.25rem;
`;


export default ModalTitle;
